<template>
    <BaseDialog
        :showDialog="showDialog"
        :close="closeDialog"
        persistent
        headline="lang_PUBLISHING_STATEMENTS_BUTTON_OPTION_ROYALTY_CONTROLLING"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid> 
                <v-row>
                    <v-col 
                        class="text-center"
                        v-html="dialogText"
                        :alvqa="alvqa + '-text'"
                    ></v-col>
                </v-row> 
            </v-container>  
        </template>
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row v-if="showConfirmationButton"> 
                    <v-col class="text-right">
                       <BaseButton 
                            @click="confirmProcess()"
                            label="lang_BUTTON_START"
                            :alvqa="alvqa+'-button-yes'"    
                        />
                    </v-col>              
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "PublishingStatementsRoyaltyControllingDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            alvqa: "publishing-statements-royalty-controlling-dialog",
            showConfirmationTriggers:true
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowPublishingStatementsRoyaltyControllingDialog },
            set(show) { return this.$store.commit('setShowPublishingStatementsRoyaltyControllingDialog', show) },
        },
        showConfirmationButton: {
            get() { return this.$store.getters.getShowPublishingStatementsRoyaltyControllingDialogConfirmationButton },
            set(show) { return this.$store.commit('setShowPublishingStatementsRoyaltyControllingDialogConfirmationButton', show) },
        },
        dialogText: {
            get() { return this.$store.getters.getPublishingStatementsRoyaltyControllingDialogText },
            set(text) { this.$store.commit('setPublishingStatementsRoyaltyControllingDialogText', text) }
        },
        actionName: {
            get() { return this.$store.getters.getPublishingStatementsRoyaltyControllingDialogAction },
            set(value) { this.$store.commit('setPublishingStatementsRoyaltyControllingDialogAction', value) }
        }
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.dialogText = ""
            this.showConfirmationButton = false
            this.actionName = null
        },
        confirmProcess(){
            // Prevent starting if already running
            if (this.$store.getters.getPublishingStatementsRoyaltyControllingInProcess) {
                this.$store.commit('setSnackbar', { type: 'warning', msg: this.$t('lang_GENERIC_MESSAGE_WARNING_PROCESS_ALREADY_RUNNING') })
                this.closeDialog()
                return
            }
            
            this.$store.dispatch('publishingStatemtensRoyaltyControlling', this.actionName)
            this.$store.commit("setPublishingStatementsRoyaltyControllingInProcess", true)
            this.$store.commit('setSnackbar', { type: 'info', msg: this.$t('lang_GENERIC_MESSAGE_INFO_PROCESS_STARTED_CHECK_DASHBOARD') })

            this.closeDialog()
        },
    },
    created() {
        
    }
}
</script>